angular.module('am4').controller('forgotRequestCtrl', function($state, $stateParams, forgotPassword, safeLogsService) {
    var that = this;

    that.email = $stateParams.email;

    that.submit = function(email) {
        that.loading = true;


        forgotPassword.request(email)
        .then(function() {
            $state.go('^.sent', {
                email: email
            });
        })
        .catch(function(e) {
            safeLogsService.log('FORGOT_REQUEST_ERROR', e);

            $state.go('^.error', {
                email: email
            });
        })
        .finally(function() {
            that.loading = false;
        });
    };

});



// WEBPACK FOOTER //
// ./src/app/controllers/forgotRequestCtrl.js